import { Schedule } from 'features/schedule';
import { AppPage } from 'common/Layout';
import { useSchedulePage } from './use-schedule-page';

export const SchedulePage = () => {
  const { breadcrumbsLoading, breadcrumbs } = useSchedulePage();

  return (
    <AppPage
      breadcrumbs={{
        items: breadcrumbs,
        loading: breadcrumbsLoading,
      }}
      documentTitle={'Расписание'}
    >
      <Schedule />
    </AppPage>
  );
};
